import { getParameterByName } from '@qdabra/forms-shared/urlHelpers';
import { URL_PARAMETER_TEMPLATE_NAME } from './Qd/constants/url.parameter.names';
import showLoadFailedError from './Qd/formsviewer/UI/loadFailedError';
import { showLoaderText } from './Qd/formsviewer/UI/uiLoader.stack.promise';
import loader from './Qd/formsviewer/loader';
import './Qd/scriptLoader.config';
import {
    FORM_LOCATION_PROP_TEMPLATE_LOCATION,
    FORM_LOCATION_PROP_TEMPLATE_LOCATION_TYPE,
    determineFormLocation,
    isLocationSpecified,
} from './formView/viewForm.formLocation';

// TODO: Move this file into formView folder

const $ = window.jQuery;

const setPageTitle = (title) => {
    document.title = title;
};

const showLoadFailedMessage = (errMsg) =>
    showLoadFailedError({ userDisplayMessage: errMsg }, $('#form'));

async function pageInit() {
    const loaderInst = loader($('#form'));

    const formLocation = determineFormLocation(getParameterByName);

    if (!isLocationSpecified(formLocation)) {
        // Deliberately not awaiting so that the popup doesn't block the loader
        showLoadFailedMessage('Please specify a template or library url.');

        return;
    }

    if (
        formLocation[FORM_LOCATION_PROP_TEMPLATE_LOCATION_TYPE] ===
        URL_PARAMETER_TEMPLATE_NAME
    ) {
        setPageTitle(formLocation[FORM_LOCATION_PROP_TEMPLATE_LOCATION]);
    }

    await loaderInst.loadForm(formLocation);
}

async function openForm() {
    try {
        await pageInit();
    } catch (ex) {
        console.error(ex);
        await showLoadFailedMessage(
            'An error occurred opening the form. Error: ' + ex.message,
        );
    }
}

const load = async function () {
    try {
        await showLoaderText('Loading...', openForm());
    } catch (e) {
        console.error(e);
    }
};

// $() doesn't call the passed function if it is async
const viewForm = () => $(() => load());

export default viewForm;
